import { Checkpoint } from 'backups/modules/BackupModule/BackupModule.types';
import moment from 'moment';
import * as R from 'ramda';

export const CheckpointUtils = {
    getFullCheckpoint(checkpointsByPlan, checkpointId) {
        return checkpointsByPlan.find(
            (checkpoint) =>
                checkpoint.id === checkpointId ||
                checkpoint.incrementalCheckpoints.some(
                    (incrementalCheckpoint) =>
                        incrementalCheckpoint.id === checkpointId,
                ),
        );
    },

    getCheckpointsForRemove({ checkpointsByPlan, checkpointId }) {
        const fullCheckpoint = CheckpointUtils.getFullCheckpoint(
            checkpointsByPlan,
            checkpointId,
        );
        if (!fullCheckpoint) {
            return [];
        }
        const { incrementalCheckpoints } = fullCheckpoint;
        const checkpointIsFull = fullCheckpoint.id === checkpointId;
        return (checkpointIsFull ? [fullCheckpoint] : [])
            .concat(
                incrementalCheckpoints.slice(
                    checkpointIsFull
                        ? 0
                        : incrementalCheckpoints.findIndex(
                              (incrementalCheckpoint) =>
                                  incrementalCheckpoint.id === checkpointId,
                          ),
                ),
            )
            .reverse(); // сначало надо удалять последние чекпоинты
    },

    getCheckpointsWithIncremental(checkpoints) {
        return [...checkpoints]
            .reverse()
            .reduce((preparedList, checkpoint) => {
                if (checkpoint.extra_info.backup_mode === 'full') {
                    preparedList.push({
                        ...checkpoint,
                        incrementalCheckpoints: [],
                    });
                } else {
                    const lastItem = preparedList[preparedList.length - 1];
                    if (lastItem) {
                        lastItem.incrementalCheckpoints.push(checkpoint);
                    } else {
                        preparedList.push({
                            ...checkpoint,
                            incrementalCheckpoints: [],
                        });
                    }
                }

                return preparedList;
            }, [])
            .reverse();
    },
    getLatestCheckpoint(checkpoints) {
        return R.reduce((latestCheckpoint, checkpoint: Checkpoint) => {
            const latestDate = moment(latestCheckpoint.created_at);
            const date = moment(checkpoint.created_at);

            if (date.isAfter(latestDate)) {
                latestCheckpoint = checkpoint;
            }

            return latestCheckpoint;
        }, checkpoints[0])(checkpoints);
    },
};
